 

import type { RouteObject } from 'react-router';
import { lazyRoute } from '../utils/lazyRoute';

const raqeebRoutes: RouteObject[] = [
  {
    path: 'RAQ/*',
    children: [
      { path: 'HomePage', lazy: lazyRoute(() => import('../../pages/HR/Raqeeb/Main/RaqeebDashboard')) },

      { path: 'RotationPlan', lazy: lazyRoute(() => import('../../pages/HR/Raqeeb/RotationPlan')) },

      {
        path: 'RotationPlan/:id/RotationSetting',
        lazy: lazyRoute(() => import('../../pages/HR/Raqeeb/RotationSetting/RotationSetting'))
      },

      {
        path: 'RotationPlan/:id/CalendarSchedules',
        lazy: lazyRoute(() => import('../../pages/HR/Raqeeb/Calendar'))
      },

      {
        path: 'RotationPlan/:id/AssignmentPerson',
        lazy: lazyRoute(() => import('../../pages/HR/Raqeeb/AssignmentPerson/AssignmentPerson'))
      },

      { path: 'AttendancAnalysis', lazy: lazyRoute(() => import('../../pages/HR/Raqeeb/AttendanceAnalysis/AttendanceAnalysis')) },

      {
        path: 'AttendanceAnalysis/AnalysisTable',
        lazy: lazyRoute(() => import('../../pages/HR/Raqeeb/AttendanceAnalysis/ResultList/AnalysisTable'))
      },

      { path: 'UpdateRaqeebData', lazy: lazyRoute(() => import('../../pages/HR/Raqeeb/UpdateData/UpdateRaqeebData')) },

      { path: 'AllFingerPrint', lazy: lazyRoute(() => import('../../pages/HR/Raqeeb/FingerPrintEmpTime/FingerPrintEmpTime')) },

      { path: 'AttendanceAdjustment', lazy: lazyRoute(() => import('../../pages/HR/Raqeeb/AttendanceAdjustment/AttendanceAdjustment')) },

      { path: 'Holidays', lazy: lazyRoute(() => import('../../pages/HR/Raqeeb/Holidays/Holidays')) },

      // Reports
      {
        path: 'Reports/*',
        children: [
          { path: '*', lazy: lazyRoute(() => import('../../pages/HR/Raqeeb/Reports/RaqeebReports')) },
          {
            path: ':ReportId/ReportsBuilder',
            lazy: lazyRoute(() =>
              import('../../pages/NTX/Reports/ReportsAllByModule/Reports/ReportsBuilder/ReportsBuilder')
            )
          }
        ]
      },

      // Dashboard
      {
        path: 'Dashboard/*',
        children: [
          { path: '*', lazy: lazyRoute(() => import('../../pages/HR/Raqeeb/Dashboard/RaqeebDashboard')) },
          {
            path: ':dashboardId/BuilderDashboard',
            lazy: lazyRoute(() =>
              import('../../pages/NTX/DashboardManagament/BuilderDashboard/BuilderDashboard')
            )
          }
        ]
      }
    ]
  }
];

export default raqeebRoutes;
